export default __webpack_public_path__ + "static/media/m-icon-gnb-btn-search.f2a6c192.svg";